import React from "react";

import {BVCtrlApi, MapCtrlApi} from "./generated/api";
import {axiosInstanceVote, configVote, serverUrlVote} from "./UtilsVote";


const bVCtrlApi = new BVCtrlApi(configVote, serverUrlVote, axiosInstanceVote);
const mapCtrlApi = new MapCtrlApi(configVote, serverUrlVote, axiosInstanceVote);


export default class ApiVoteCtrl extends React.Component {


    static getAlldata(codeInsee, callback) {
        bVCtrlApi.voteAllGet(codeInsee).then((result) => {
            callback(result.data);
        })
    }

    static getBVdata(codeInsee, callback) {
        bVCtrlApi.voteGet(codeInsee).then((result) => {
            callback(result.data);
        })
    }

    static getShape(codeInsee, callback) {
        bVCtrlApi.voteShapeGet(codeInsee).then((result) => {
            callback(result.data);
        })
    }

    static generateMinatures(codeInsee, hash, lat, lon, listOfIris, callback) {
        mapCtrlApi.mapGenerateGet(codeInsee, hash, lat, listOfIris, lon).then((result) => {
            callback(result.data);
        })
    }


}
